<div id="poll-container" [ngClass]="isMobile ? 'poll-container-mob mt-10' : 'mt-10'">

  <div *ngFor="let round of rounds; let i = index" class="round-card w-90 margin-auto"
    [ngClass]="isMobile ? 'w-90 margin-auto' : 'w-full'">
    <div [ngClass]="isMobile ? 'flex-col align-items-center' : 'flex-row content-between'">
      <div class="flex-row align-items-center gap-20">
        <img src="assets/list-icon.svg" alt="list-icon" class="icon" width="40px">
        <div class="flex-col">
          <p class="no-margin dark-blue">{{i + 1}} <sup style="top: -4px; left: -2px; font-size: 10px;">{{i === 0 ?
              'ère' : 'ème'}}</sup> élection
          </p>
          <p class="no-margin dark-blue bold">
            {{round.title}}
          </p>
        </div>
      </div>
      <div>
        <button
          [ngClass]="{ 'action-button': !votedStatuses[i], 'action-button-disabled': votedStatuses[i], 'mt-10': isMobile }"
          (click)="!votedStatuses[i] && setActiveElection(i)">
          <p *ngIf="!votedStatuses[i]" class="no-margin">FAIRE MON CHOIX</p>
           <i *ngIf="votedStatuses[i]" class="pi pi-check"
              style="color: #17D425; font-size: 24px; font-weight: 900; stroke: #17D425; stroke-width: 4px;"></i>
        </button>
      </div>
    </div>
  </div>
</div>